import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
  DataTableServerQuery,
  DataTableColumnBadgeProps,
  DataTableColumnHtmlProps,
} from '../../../../components/data-table-builder/data-table.types';
import { EmailTraceRepository } from '../../../../store/email-trace-state/email-trace-state.repository';
import { EmailTrace } from '@/types/email-trace.types';

interface getEmailTraceDataTableStructureProps {
  store: EmailTraceRepository;
  rowActions?: DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getEmailTraceDataTableStructure = ({ store, rowActions, serverQuery }: getEmailTraceDataTableStructureProps): DynamicDataTable => {
  const typeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.emailTrace.table.type',
    accessorKey: 'type_email',
    variant: DataTableColumnVariant.TEXT,
  };
  const objectColumn: DynamicDataTableColumn<DataTableColumnHtmlProps> = {
    label: 'settings.emailTrace.table.object',
    accessorKey: 'objet',
    variant: DataTableColumnVariant.HTML,
  };
  const recipientColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.emailTrace.table.recipient',
    accessorKey: 'destinataire',
    variant: DataTableColumnVariant.TEXT,
  };
  const successColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'settings.emailTrace.table.success',
    accessorKey: 'successSend',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean | number) => {
      const isSuccess = value === true || value === 1;
      return {
        value: isSuccess ? 'settings.emailTrace.table.successSent' : 'settings.emailTrace.table.successFailed',
      };
    },
    props: {
      getSeverity: (value: boolean | number) => {
        const isSuccess = value === true || value === 1;
        return isSuccess ? 'success' : 'danger';
      },
    },
  };
  const dateColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.emailTrace.table.date',
    accessorKey: 'dateSend',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };
  const createdAtColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.emailTrace.table.createdAt',
    accessorKey: 'createdAt',
    variant: DataTableColumnVariant.DATE,
    props: {
      format: 'dd/MM/yyyy HH:mm',
    },
  };

  return {
    singular: 'settings.emailTrace.table.singular',
    plural: 'settings.emailTrace.table.plural',
    columns: [typeColumn, objectColumn, recipientColumn, successColumn, dateColumn, createdAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    enableServerActions: true,
    serverQuery,
    target: row => {
      store.set('dto', {
        id: row.id,
        type_email: row.type_email,
        objet: row.objet,
        contenu: row.contenu,
        destinataire: row.destinataire,
        successSend: row.successSend,
        dateSend: row.dateSend,
        createdAt: row.createdAt,
        createdBy: row.createdBy,
        updatedAt: row.updatedAt,
        updatedBy: row.updatedBy,
        isDeleted: row.isDeleted,
      });
      store.set('response', row);
      store.set('selectedEmailTrace', row);
    },
    rowActionsFn: (row: EmailTrace) => {
      const actions: DataTableRowActions = {};
      // Add inspect action for all emails
      actions.inspectAction = rowActions?.inspectAction;
      // Add resend action only for failed emails
      const isSuccess = row.successSend === true || row.successSend === 1;
      if (!isSuccess) {
        actions.resendAction = rowActions?.resendAction;
      }
      return actions;
    },
  };
};
